import { render, staticRenderFns } from "./DigitalAgreementSignaturePad.vue?vue&type=template&id=876923d6&scoped=true"
import script from "./DigitalAgreementSignaturePad.vue?vue&type=script&lang=js"
export * from "./DigitalAgreementSignaturePad.vue?vue&type=script&lang=js"
import style0 from "./DigitalAgreementSignaturePad.vue?vue&type=style&index=0&id=876923d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876923d6",
  null
  
)

export default component.exports